module.exports = __webpack_public_path__ + "img/2-2.8e0d8da8.png";